"use client";

import { AnimatedBadge } from "@/components/motion/animated-badge";
import { SectionHeading } from "@/components/marketing/section-heading";

interface Post {
  id: string;
  title: string;
  summary: string;
  author: string;
  published: string;
  label: string;
  image: string;
  url: string;
}

interface Blog28Props {
  tagline?: string;
  heading?: string;
  description?: string;
  buttonText?: string;
  buttonUrl?: string;
  posts?: Post[];
}

const Blog28 = ({ tagline, heading, description, posts = [] }: Blog28Props) => {
  return (
    <div className="py-20 lg:py-36">
      {heading || description ? (
        <SectionHeading
          badge={tagline}
          title={heading || <span className="text-neutral-500">{description}</span>}
          subtitle={heading ? description : undefined}
          breakBeforeSubtitle
        />
      ) : (
        tagline && (
          <AnimatedBadge status="info" size="sm" showIcon={false} className="w-fit">{tagline}</AnimatedBadge>
        )
      )}

      <div className="grid grid-cols-1 gap-6 mt-12 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2">
        {posts[0] && (
          <div className="relative sm:col-span-2 lg:row-span-2">
            <a href={posts[0].url} className="block h-fit md:top-0 ">
              <div className="flex h-full w-full ">
                {posts[0].image ? (
                  <img
                    src={posts[0].image}
                    alt={posts[0].title}
                    className="h-full w-full object-cover "
                  />
                ) : (
                  <div className="h-full w-full bg-neutral-100" />
                )}
              </div>
              <div className="mt-5">
                <div className="mb-2.5 flex items-center gap-1 text-sm text-muted-foreground">
                  <time>{posts[0].published}</time>·
                  <span>{posts[0].author}</span>
                </div>
                <h3 className="text-lg md:text-3xl lg:text-4xl">
                  {posts[0].title}
                </h3>
                <p className="mt-4 text-muted-foreground">{posts[0].summary}</p>
              </div>
            </a>
          </div>
        )}
        {posts.slice(1).map((post) => (
          <a
            key={post.id}
            href={post.url}
            className="flex flex-col gap-4 lg:row-span-2"
          >
            <div className="w-full flex-1 max-h-157">
              {post.image ? (
                <img
                  src={post.image}
                  alt={post.title}
                  className="object-cover h-full "
                />
              ) : (
                <div className="h-full w-full bg-neutral-100" />
              )}
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-1 text-sm text-muted-foreground">
                <time>{post.published}</time>·<span>{post.author}</span>
              </div>
              <h3 className="text-lg">{post.title}</h3>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export { Blog28 };
